module.exports = __webpack_public_path__ + "images/popular-f7d02992c2767ecbb88348a928d3927b.png";